import { createContext } from 'react'

const GuestJourneyContext = createContext()

export default GuestJourneyContext
